import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import {Switch, Space} from "antd";

import {
    getAllRiskImpact,
    clear_risk_impact,
    createRiskImpact,
    CREATE_RISK_IMPACT,
    updateRiskImpact,
    UPDATE_RISK_IMPACT
} from "../../../redux/risk_impacts";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Footer from "../../../components/footer";

const RiskImpact = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_risk_impact = useSelector((state) => state.risk_impact_module._get_all_risk_impact);
    const _create_risk_impact = useSelector((state) => state.risk_impact_module._create_risk_impact);
    const _update_risk_impact = useSelector((state) => state.risk_impact_module._update_risk_impact);

    const [data, setData] = useState([]);

    useEffect(() => {
        if (_get_all_risk_impact.data.datos) {
            setData(_get_all_risk_impact.data.datos);
        }
    }, [_get_all_risk_impact]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        descripcion: "",
        por_defecto: false,
        activo: true,
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_riskimpacts').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        setForm({...form, descripcion: item.descripcion, por_defecto: item.por_defecto, activo: item.activo});
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };
    
    const handleCheckedDefaultChange = (checked) => {
        setForm({
            ...form,
            por_defecto: checked,
        });
    };
    
    useEffect(() => {
        if (_create_risk_impact.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_risk_impact(CREATE_RISK_IMPACT));
            dispatch(getAllRiskImpact(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_risk_impact.status !== 0) {
            dispatch(clear_risk_impact(CREATE_RISK_IMPACT));
            toast.error(_create_risk_impact.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_risk_impact, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_risk_impact.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_risk_impact(UPDATE_RISK_IMPACT));
            dispatch(getAllRiskImpact(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_risk_impact.status !== 0) {
            dispatch(clear_risk_impact(UPDATE_RISK_IMPACT));
            toast.error(_update_risk_impact.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_risk_impact, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.descripcion === "") {
            toast.error("Debe ingresar la descripción", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(createRiskImpact(token, form));
        } else {
            dispatch(updateRiskImpact(token, id, form));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Impactos de riesgos", link: "/impactos-riesgos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_riskimpacts').length > 0 ?
                                        <Button type="button" text="Crear" theme="calendar" onClick={() => {
                                            setModal(true);
                                            setForm({...form, descripcion: '', por_defecto: false, activo: true});
                                            setId(0);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "descripcion",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "por_defecto",
                                                label: "Por defecto",
                                                type: "boolean",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">{id === 0 ? 'Crear ' : 'Editar '} impacto de riesgo</h5>
                        <div className="form-group">
                            <Input
                                label="Clasificación"
                                name="descripcion"
                                value={form.descripcion}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Space size={14} direction='horizontal'>
                                <strong>Por defecto</strong>
                                <Switch
                                    checked={form.por_defecto}
                                    checkedChildren="SI"
                                    unCheckedChildren="NO"
                                    onChange={handleCheckedDefaultChange}
                                />
                            </Space>
                        </div>
                        {id !== 0 &&
                            <div className="form-group">
                                <Space size={14} direction='horizontal'>
                                    <strong>Activo</strong>
                                    <Switch
                                        checked={form.activo}
                                        checkedChildren="SI"
                                        unCheckedChildren="NO"
                                        onChange={handleCheckedChange}
                                    />
                                </Space>
                            </div>
                        }
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-calendar mb-1 button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default RiskImpact;
